import ScrollSideBar from "@/Layouts/components/SideBars/ScrollSideBar/ScrollSideBar";

type TMenu = {
	elementId: string;
	label: string;
};

type TSystemSettingsSideBarProps = {
	menus: TMenu[];
	selected?: string;
	loading?: boolean;
	onActionClick?: (selected: TMenu) => void;
};

const SystemSettingsSideBar = (props: Readonly<TSystemSettingsSideBarProps>) => {
	const { menus, loading = false, selected = null, onActionClick = () => {} } = props;
	return (
		<ScrollSideBar
			title={"Settings"}
			position={"sticky"}
			top={"190px"}
			menus={menus || []}
			selected={selected}
			selectBy={"elementId"}
			showBy={"label"}
			scrollBy={"elementId"}
			listItemClasses={"system-settings-list-item"}
			defaultSelection
			titleSx={{ marginLeft: "6px" }}
			onActionClick={onActionClick}
			loading={loading}
		/>
	);
};

export default SystemSettingsSideBar;
